import React from 'react';
export function Footer() {
  return <footer className="py-8 border-t border-mystic-800 bg-mystic-900 relative z-10 text-center" data-id="element-134">
      <div className="container mx-auto px-4" data-id="element-135">
        <p className="font-serif text-gold text-xl font-bold mb-4" data-id="element-136">
          MegaPack Tarot Profesional
        </p>
        <p className="text-white/40 text-sm" data-id="element-137">
          &copy; {new Date().getFullYear()} Todos los derechos reservados.
        </p>
        <div className="mt-4 flex justify-center gap-4 text-xs text-white/30" data-id="element-138">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-139">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-140">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}